// extracted by mini-css-extract-plugin
module.exports = {"definition":"Navigation__definition","chapter-button-size":"Navigation__chapter-button-size","root":"Navigation__root","nav":"Navigation__nav Navigation__nav___9450c nav","background":"Navigation__background","monogramPlaceholder":"Navigation__monogramPlaceholder"};
    if(module.hot) {
      // 1790535732188
      var cssReload = require("/var/lib/jenkins/workspace/Player_master/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"locals":true});
      module.hot.dispose(cssReload);
      
    }
  